<mat-checkbox [checked]="checkState" [disabled]="disabled" (change)="onCheckChange($event.checked, true)" color="primary">
</mat-checkbox>
